// extracted by mini-css-extract-plugin
export default {"backdrop":"backdrop__+r1iD","loader-content":"loader-content__DfMRy","loaderContent":"loader-content__DfMRy"};